import { render, staticRenderFns } from "./settlement-receipt.vue?vue&type=template&id=f983108c&scoped=true&"
import script from "./settlement-receipt.vue?vue&type=script&lang=js&"
export * from "./settlement-receipt.vue?vue&type=script&lang=js&"
import style0 from "./settlement-receipt.vue?vue&type=style&index=0&id=f983108c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f983108c",
  null
  
)

export default component.exports